module.exports = __webpack_public_path__ + "img/angular.33242af6.png";